// import React, { useState, useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { Modal } from 'react-bootstrap';
// import {
//   FaShoppingCart,
//   FaSearch,
//   FaEye,
//   FaTimes,
//   FaChevronLeft,
//   FaChevronRight,
//   FaChevronUp,
//   FaFilter,
//   FaChevronDown,
//   FaChair,
//   FaBed,
//   FaTable,
//   FaCouch,
//   FaBoxes,
//   FaPaintBrush,
//   FaLightbulb,
//   FaGem,
//   FaPalette,
//   FaVideo,
//   FaPlay,
//   FaExpand,
//   FaPause,
//   FaMinus,
//   FaPlus,
//   FaTrash,
//   FaInfoCircle,
//   FaRulerCombined,
//   FaMapMarkerAlt,
//   FaTag,
//   FaCheckCircle,
//   FaTimesCircle,
// } from 'react-icons/fa';
// import './readyproducts.scss';
// import withAuth from '../../../auth/WithAuth';
// import FurnitureNavbar from '../../../../components/layout/Nav';
// import { serverUrlAuth } from '../../../../serverUrl';
// import { toast } from 'react-toastify';

// // Category configurations
// const CATEGORY_CONFIG = [
//   { id: 'furniture', name: 'Furniture', icon: FaChair },
//   { id: 'decor', name: 'Home Decor', icon: FaPaintBrush },
//   { id: 'art', name: 'Art & Crafts', icon: FaPaintBrush },
//   { id: 'clothing', name: 'Clothing', icon: FaBoxes },
//   { id: 'other', name: 'Other', icon: FaBoxes },
// ];

// // Budget range presets
// const BUDGET_PRESETS = [
//   { label: 'Under KSh 5,000', min: 0, max: 5000 },
//   { label: 'KSh 5,000 - KSh 10,000', min: 5000, max: 10000 },
//   { label: 'KSh 10,000 - KSh 25,000', min: 10000, max: 25000 },
//   { label: 'KSh 25,000 - KSh 50,000', min: 25000, max: 50000 },
//   { label: 'KSh 50,000 - KSh 100,000', min: 50000, max: 100000 },
//   { label: 'Over KSh 100,000', min: 100000, max: Infinity },
// ];

// const ReadyProductsView = () => {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedCategory, setSelectedCategory] = useState('all');
//   const [categories, setCategories] = useState([]);
//   const [cart, setCart] = useState(null);
//   const [loadingItems, setLoadingItems] = useState({});
//   const [sortBy, setSortBy] = useState('featured');
//   const [priceRange, setPriceRange] = useState({ min: 0, max: 1000000 });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(8);
//   const [showScrollTop, setShowScrollTop] = useState(false);
//   const [showMobileFilters, setShowMobileFilters] = useState(false);
//   const [selectedBudgetPreset, setSelectedBudgetPreset] = useState(null);

//   // Quick view modal state
//   const [showQuickView, setShowQuickView] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [selectedVariantIndex, setSelectedVariantIndex] = useState(0);
  
//   // Lightbox state
//   const [showLightbox, setShowLightbox] = useState(false);
//   const [lightboxImages, setLightboxImages] = useState([]);
//   const [lightboxIndex, setLightboxIndex] = useState(0);

//   // Video ref
//   const videoRef = useRef(null);

//   useEffect(() => {
//     fetchProducts();
//     fetchCart();

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Build categories from actual products after fetching
//   useEffect(() => {
//     if (products.length > 0) {
//       buildCategoriesFromProducts();
//     }
//   }, [products]);

//   const fetchProducts = async () => {
//     try {
//       setLoading(true);
//       const response = await serverUrlAuth.get(
//         'projects/client-list-ready-made-products/',
//       );
//       console.log('Products:', response.data);
//       setProducts(response.data);
//     } catch (error) {
//       console.error('Error fetching products:', error);
//       toast.error('Failed to load products');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchCart = async () => {
//     try {
//       const response = await serverUrlAuth.get('cart/');
//       console.log('Cart response:', response.data);
//       setCart(response.data);
//     } catch (error) {
//       console.error('Error fetching cart:', error);
//     }
//   };

//   // Build categories dynamically from products
//   const buildCategoriesFromProducts = () => {
//     const categoryMap = new Map();
    
//     products.forEach(product => {
//       const category = product.category || 'furniture';
//       const config = CATEGORY_CONFIG.find(c => c.id === category);
//       const categoryName = config ? config.name : category.charAt(0).toUpperCase() + category.slice(1);
//       const Icon = config ? config.icon : FaBoxes;
      
//       if (!categoryMap.has(category)) {
//         categoryMap.set(category, {
//           id: category,
//           name: categoryName,
//           icon: Icon,
//           count: 0
//         });
//       }
//       categoryMap.get(category).count++;
//     });

//     const categoriesArray = Array.from(categoryMap.values()).sort((a, b) => b.count - a.count);
//     setCategories(categoriesArray);
//   };

//   const handleScroll = () => {
//     if (window.pageYOffset > 300) {
//       setShowScrollTop(true);
//     } else {
//       setShowScrollTop(false);
//     }
//   };

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   // Check if a variant is on sale
//   const isVariantOnSale = (variant) => {
//     if (!variant) return false;
//     // Use the is_on_sale field from the API if available
//     if (variant.is_on_sale !== undefined) {
//       return variant.is_on_sale === true;
//     }
//     // Fallback to date checking
//     if (!variant.sale_start_date || !variant.sale_end_date) return false;
//     const now = new Date();
//     const start = new Date(variant.sale_start_date);
//     const end = new Date(variant.sale_end_date);
//     return now >= start && now <= end;
//   };

//   // Get the current price for a variant
//   const getVariantCurrentPrice = (variant) => {
//     if (!variant) return 0;
//     if (isVariantOnSale(variant) && variant.selling_price) {
//       return parseFloat(variant.selling_price);
//     }
//     return parseFloat(variant.original_price || 0);
//   };

//   // Get the original price for a variant (for display)
//   const getVariantOriginalPrice = (variant) => {
//     if (!variant) return 0;
//     return parseFloat(variant.original_price || 0);
//   };

//   // Get discount percentage for a variant
//   const getVariantDiscountPercentage = (variant) => {
//     if (!variant) return 0;
//     if (!isVariantOnSale(variant)) return 0;
//     const original = parseFloat(variant.original_price || 0);
//     const selling = parseFloat(variant.selling_price || 0);
//     if (original === 0 || selling === 0) return 0;
//     return Math.round(((original - selling) / original) * 100);
//   };

//   // Get product's lowest current price from variants
//   const getProductPrice = (product) => {
//     if (!product.variants || product.variants.length === 0) {
//       return 0;
//     }
//     const prices = product.variants.map(v => getVariantCurrentPrice(v));
//     return Math.min(...prices);
//   };

//   // Get product's price range
//   const getProductPriceRange = (product) => {
//     if (!product.variants || product.variants.length === 0) {
//       return 'KSh 0';
//     }
//     const prices = product.variants.map(v => getVariantCurrentPrice(v));
//     const min = Math.min(...prices);
//     const max = Math.max(...prices);
//     if (min === max) return formatCurrency(min);
//     return `${formatCurrency(min)} - ${formatCurrency(max)}`;
//   };

//   // Get product's original price range (for sale display)
//   const getProductOriginalPriceRange = (product) => {
//     if (!product.variants || product.variants.length === 0) {
//       return null;
//     }
//     const prices = product.variants.map(v => getVariantOriginalPrice(v));
//     const min = Math.min(...prices);
//     const max = Math.max(...prices);
//     if (min === max) return formatCurrency(min);
//     return `${formatCurrency(min)} - ${formatCurrency(max)}`;
//   };

//   // Check if any variant is on sale
//   const isProductOnSale = (product) => {
//     if (!product.variants || product.variants.length === 0) return false;
//     return product.variants.some(v => isVariantOnSale(v));
//   };

//   // Get the highest discount percentage among variants
//   const getProductDiscountPercentage = (product) => {
//     if (!product.variants || product.variants.length === 0) return 0;
//     const discounts = product.variants.map(v => getVariantDiscountPercentage(v));
//     return Math.max(...discounts);
//   };

//   // Get product's total stock from variants
//   const getProductStock = (product) => {
//     if (!product.variants || product.variants.length === 0) {
//       return 0;
//     }
//     return product.variants.reduce((sum, v) => sum + (v.stock || 0), 0);
//   };

//   // Get product's first image from variants
//   const getProductImage = (product) => {
//     if (product.variants && product.variants.length > 0) {
//       const firstVariant = product.variants[0];
//       if (firstVariant.images && firstVariant.images.length > 0) {
//         return firstVariant.images[0].image_url || firstVariant.images[0].image;
//       }
//     }
//     return 'https://via.placeholder.com/300x200?text=No+Image';
//   };

//   // Get all images from a specific variant
//   const getVariantImages = (product, variantIndex) => {
//     if (!product.variants || !product.variants[variantIndex]) {
//       return [];
//     }
//     const variant = product.variants[variantIndex];
//     if (variant.images && variant.images.length > 0) {
//       return variant.images.map(img => img.image_url || img.image);
//     }
//     return [];
//   };

//   // Get video URL for a variant
//   const getVariantVideo = (product, index) => {
//     if (!product.variants || !product.variants[index]) {
//       return null;
//     }
//     const variant = product.variants[index];
//     if (variant.video) {
//       return variant.video.video_url || variant.video;
//     }
//     return null;
//   };

//   // Open lightbox with images
//   const openLightbox = (images, index = 0) => {
//     if (images && images.length > 0) {
//       setLightboxImages(images);
//       setLightboxIndex(index);
//       setShowLightbox(true);
//     }
//   };

//   const closeLightbox = () => {
//     setShowLightbox(false);
//     setLightboxImages([]);
//     setLightboxIndex(0);
//   };

//   // Updated addToCart - sends variant_id instead of product_id
//   const addToCart = async (product, variantIndex, quantity = 1) => {
//     const variant = product.variants?.[variantIndex];
//     if (!variant) {
//       toast.error('Variant not found');
//       return;
//     }

//     if (variant.stock === 0) {
//       toast.error('Sorry, this item is out of stock!');
//       return;
//     }

//     const loadingKey = `${product.id}-${variant.id}`;
//     setLoadingItems((prev) => ({ ...prev, [loadingKey]: true }));

//     try {
//       const response = await serverUrlAuth.post('cart/add/', {
//         variant_id: variant.id,
//         quantity: quantity,
//       });

//       console.log('Add to cart response:', response.data);
//       await fetchCart();
      
//       const variantName = variant.color_name || '';
//       toast.success(`${quantity} ${product.name}${variantName ? ` (${variantName})` : ''} added to cart!`);

//       if (showQuickView) {
//         handleCloseQuickView();
//       }
//     } catch (error) {
//       console.error('Error adding to cart:', error);
//       toast.error(error.response?.data?.error || 'Failed to add to cart');
//     } finally {
//       setLoadingItems((prev) => ({ ...prev, [loadingKey]: false }));
//     }
//   };

//   const handleQuickView = (product) => {
//     setSelectedProduct({
//       ...product,
//       quantity: 1,
//       selectedVariantIndex: 0,
//     });
//     setSelectedVariantIndex(0);
//     setShowQuickView(true);
//   };

//   const handleCloseQuickView = () => {
//     setShowQuickView(false);
//     setSelectedProduct(null);
//     setSelectedVariantIndex(0);
//   };

//   // Handle variant change in quick view
//   const handleVariantChange = (index) => {
//     setSelectedVariantIndex(index);
//     if (selectedProduct) {
//       setSelectedProduct({
//         ...selectedProduct,
//         selectedVariantIndex: index,
//       });
//     }
//   };

//   // Handle budget preset selection
//   const handleBudgetPresetSelect = (preset) => {
//     setSelectedBudgetPreset(preset.label);
//     setPriceRange({ min: preset.min, max: preset.max });
//     setCurrentPage(1);
//   };

//   // Handle custom price range input
//   const handleCustomPriceRange = (type, value) => {
//     let newMin = priceRange.min;
//     let newMax = priceRange.max;

//     if (type === 'min') {
//       newMin = value;
//     } else {
//       newMax = value;
//     }

//     setPriceRange({ min: newMin, max: newMax });
//     setSelectedBudgetPreset(null);
//     setCurrentPage(1);
//   };

//   // Clear all filters including budget
//   const clearAllFilters = () => {
//     setSelectedCategory('all');
//     setSearchTerm('');
//     setPriceRange({ min: 0, max: 1000000 });
//     setSortBy('featured');
//     setSelectedBudgetPreset(null);
//     setShowMobileFilters(false);
//   };

//   // Get category icon component
//   const getCategoryIcon = (categoryId) => {
//     const category = CATEGORY_CONFIG.find(c => c.id === categoryId);
//     if (category && category.icon) {
//       const Icon = category.icon;
//       return <Icon />;
//     }
//     return <FaBoxes />;
//   };

//   // Filter and sort products
//   const filteredProducts = products
//     .filter((product) => {
//       const matchesSearch =
//         product.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         product.description?.toLowerCase().includes(searchTerm.toLowerCase());

//       const matchesCategory =
//         selectedCategory === 'all' ||
//         (product.category?.toLowerCase() === selectedCategory.toLowerCase());

//       const productPrice = getProductPrice(product);
//       const matchesPrice = productPrice >= priceRange.min && productPrice <= priceRange.max;

//       return matchesSearch && matchesCategory && matchesPrice;
//     })
//     .sort((a, b) => {
//       const priceA = getProductPrice(a);
//       const priceB = getProductPrice(b);
//       switch (sortBy) {
//         case 'price-low':
//           return priceA - priceB;
//         case 'price-high':
//           return priceB - priceA;
//         case 'newest':
//           return new Date(b.created_at) - new Date(a.created_at);
//         default:
//           return 0;
//       }
//     });

//   // Pagination
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredProducts.slice(
//     indexOfFirstItem,
//     indexOfLastItem,
//   );
//   const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

//   const paginate = (pageNumber) => {
//     setCurrentPage(pageNumber);
//     if (window.innerWidth <= 768) {
//       document
//         .querySelector('.products-grid')
//         ?.scrollIntoView({ behavior: 'smooth' });
//     }
//   };

//   // Get category display name
//   const getCategoryDisplayName = (categoryId) => {
//     const category = CATEGORY_CONFIG.find(c => c.id === categoryId);
//     return category ? category.name : (categoryId || 'Furniture');
//   };

//   // Handle lightbox navigation with keyboard
//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (showLightbox) {
//         if (e.key === 'ArrowLeft') {
//           setLightboxIndex((prev) => 
//             prev === 0 ? lightboxImages.length - 1 : prev - 1
//           );
//         } else if (e.key === 'ArrowRight') {
//           setLightboxIndex((prev) => 
//             prev === lightboxImages.length - 1 ? 0 : prev + 1
//           );
//         } else if (e.key === 'Escape') {
//           closeLightbox();
//         }
//       }
//     };

//     window.addEventListener('keydown', handleKeyDown);
//     return () => window.removeEventListener('keydown', handleKeyDown);
//   }, [showLightbox, lightboxImages.length]);

//   // Get cart item count
//   const getCartItemCount = () => {
//     if (!cart || !cart.items) return 0;
//     return cart.items.reduce((sum, item) => sum + item.quantity, 0);
//   };

//   return (
//     <>
//       <FurnitureNavbar />
//       <div className="ready-products-page">
//         {/* Hero Banner */}
//         <div className="shop-hero">
//           <div className="hero-content">
//             <h1>Ready Made Products</h1>
//             <p>
//               Discover unique, handcrafted pieces from talented artisans around
//               the world.
//             </p>
//           </div>
//         </div>

//         <div className="shop-container">
//           {/* Mobile Filter Toggle */}
//           <button
//             className="mobile-filter-toggle"
//             onClick={() => setShowMobileFilters(!showMobileFilters)}
//             aria-label="Toggle filters"
//           >
//             <FaFilter /> Filters
//             <span className="filter-count">
//               {selectedCategory !== 'all' ||
//               searchTerm ||
//               priceRange.min > 0 ||
//               priceRange.max < 1000000
//                 ? '●'
//                 : ''}
//             </span>
//             <FaChevronDown
//               className={`arrow ${showMobileFilters ? 'open' : ''}`}
//             />
//           </button>

//           <div className="shop-layout">
//             {/* Sidebar Filters */}
//             <aside
//               className={`shop-sidebar ${showMobileFilters ? 'show' : ''}`}
//             >
//               <div className="sidebar-header">
//                 <h3>Filters</h3>
//                 <button
//                   className="close-sidebar"
//                   onClick={() => setShowMobileFilters(false)}
//                   aria-label="Close filters"
//                 >
//                   <FaTimes />
//                 </button>
//               </div>

//               {/* Categories Filter */}
//               {categories.length > 0 && (
//                 <div className="filter-section">
//                   <h4>Categories</h4>
//                   <div className="category-list">
//                     <button
//                       className={`category-item ${selectedCategory === 'all' ? 'active' : ''}`}
//                       onClick={() => {
//                         setSelectedCategory('all');
//                         setShowMobileFilters(false);
//                       }}
//                     >
//                       <span>All Categories</span>
//                       <span className="count">{products.length}</span>
//                     </button>
//                     {categories.map((cat) => {
//                       const Icon = cat.icon;
//                       return (
//                         <button
//                           key={cat.id}
//                           className={`category-item ${selectedCategory === cat.id ? 'active' : ''}`}
//                           onClick={() => {
//                             setSelectedCategory(cat.id);
//                             setShowMobileFilters(false);
//                           }}
//                         >
//                           <span>
//                             <Icon /> {cat.name}
//                           </span>
//                           <span className="count">{cat.count}</span>
//                         </button>
//                       );
//                     })}
//                   </div>
//                 </div>
//               )}

//               {/* Budget Filter Section */}
//               <div className="filter-section">
//                 <h4>Filter by Budget</h4>

//                 <div className="budget-presets">
//                   {BUDGET_PRESETS.map((preset) => (
//                     <button
//                       key={preset.label}
//                       className={`budget-preset-btn ${selectedBudgetPreset === preset.label ? 'active' : ''}`}
//                       onClick={() => handleBudgetPresetSelect(preset)}
//                     >
//                       {preset.label}
//                     </button>
//                   ))}
//                 </div>

//                 {(priceRange.min > 0 || priceRange.max < 1000000) && (
//                   <div className="active-budget-range">
//                     <span>Current budget: </span>
//                     <strong>
//                       {priceRange.min > 0
//                         ? `KSh ${priceRange.min.toLocaleString()}`
//                         : 'KSh 0'}{' '}
//                       -{' '}
//                       {priceRange.max === Infinity
//                         ? 'Any'
//                         : `KSh ${priceRange.max.toLocaleString()}`}
//                     </strong>
//                     <button
//                       className="clear-budget"
//                       onClick={() => {
//                         setPriceRange({ min: 0, max: 1000000 });
//                         setSelectedBudgetPreset(null);
//                       }}
//                     >
//                       Clear
//                     </button>
//                   </div>
//                 )}
//               </div>

//               {/* Price Range Filter */}
//               <div className="filter-section">
//                 <h4>Price Range (KSh)</h4>
//                 <div className="price-range">
//                   <div className="price-inputs">
//                     <div className="input-group">
//                       <label htmlFor="min-price-alt">Min</label>
//                       <input
//                         id="min-price-alt"
//                         type="number"
//                         value={priceRange.min}
//                         onChange={(e) =>
//                           handleCustomPriceRange('min', Number(e.target.value))
//                         }
//                         placeholder="0"
//                         min="0"
//                       />
//                     </div>
//                     <span className="range-separator">to</span>
//                     <div className="input-group">
//                       <label htmlFor="max-price-alt">Max</label>
//                       <input
//                         id="max-price-alt"
//                         type="number"
//                         value={
//                           priceRange.max === Infinity ? '' : priceRange.max
//                         }
//                         onChange={(e) =>
//                           handleCustomPriceRange('max', Number(e.target.value))
//                         }
//                         placeholder="1000000"
//                         min="0"
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Filter Actions */}
//               <div className="filter-actions">
//                 <button
//                   className="apply-filters-btn"
//                   onClick={() => setShowMobileFilters(false)}
//                 >
//                   Apply Filters
//                 </button>
//                 <button className="clear-filters-btn" onClick={clearAllFilters}>
//                   Clear All
//                 </button>
//               </div>
//             </aside>

//             {/* Main Content */}
//             <main className="shop-main">
//               {/* Search and Sort Bar */}
//               <div className="shop-toolbar">
//                 <div className="search-box">
//                   <FaSearch className="search-icon" />
//                   <input
//                     type="text"
//                     placeholder="Search products..."
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                     aria-label="Search products"
//                   />
//                   {searchTerm && (
//                     <button
//                       className="clear-search"
//                       onClick={() => setSearchTerm('')}
//                       aria-label="Clear search"
//                     >
//                       <FaTimes />
//                     </button>
//                   )}
//                 </div>

//                 <div className="sort-box">
//                   <select
//                     value={sortBy}
//                     onChange={(e) => setSortBy(e.target.value)}
//                     aria-label="Sort products by"
//                   >
//                     <option value="featured">Featured</option>
//                     <option value="price-low">Price: Low to High</option>
//                     <option value="price-high">Price: High to Low</option>
//                     <option value="newest">Newest</option>
//                   </select>
//                 </div>
//               </div>

//               {/* Active Filters Display */}
//               {(selectedCategory !== 'all' ||
//                 searchTerm ||
//                 priceRange.min > 0 ||
//                 priceRange.max < 1000000) && (
//                 <div className="active-filters">
//                   <span>Active filters:</span>
//                   {selectedCategory !== 'all' && (
//                     <span className="filter-tag">
//                       {getCategoryDisplayName(selectedCategory)}
//                       <button onClick={() => setSelectedCategory('all')}>
//                         ×
//                       </button>
//                     </span>
//                   )}
//                   {searchTerm && (
//                     <span className="filter-tag">
//                       Search: {searchTerm}
//                       <button onClick={() => setSearchTerm('')}>×</button>
//                     </span>
//                   )}
//                   {(priceRange.min > 0 || priceRange.max < 1000000) && (
//                     <span className="filter-tag">
//                       Budget:{' '}
//                       {priceRange.min > 0
//                         ? `KSh ${priceRange.min.toLocaleString()}`
//                         : 'KSh 0'}{' '}
//                       -{' '}
//                       {priceRange.max === Infinity
//                         ? 'Any'
//                         : `KSh ${priceRange.max.toLocaleString()}`}
//                       <button
//                         onClick={() => {
//                           setPriceRange({ min: 0, max: 1000000 });
//                           setSelectedBudgetPreset(null);
//                         }}
//                       >
//                         ×
//                       </button>
//                     </span>
//                   )}
//                   <button
//                     className="clear-all-filters"
//                     onClick={clearAllFilters}
//                   >
//                     Clear all
//                   </button>
//                 </div>
//               )}

//               {/* Results Info */}
//               {!loading && filteredProducts.length > 0 && (
//                 <div className="results-info">
//                   <p>
//                     Showing{' '}
//                     <span>
//                       {indexOfFirstItem + 1}-
//                       {Math.min(indexOfLastItem, filteredProducts.length)}
//                     </span>{' '}
//                     of <span>{filteredProducts.length}</span> products
//                   </p>
//                 </div>
//               )}

//               {/* Products Grid */}
//               {loading ? (
//                 <div className="loading-container">
//                   <div className="spinner"></div>
//                   <p>Discovering amazing creations...</p>
//                 </div>
//               ) : (
//                 <>
//                   <div className="products-grid">
//                     {currentItems.length > 0 ? (
//                       currentItems.map((product) => {
//                         const totalStock = getProductStock(product);
//                         const priceRange = getProductPriceRange(product);
//                         const isOutOfStock = totalStock === 0;
//                         const isOnSale = isProductOnSale(product);
//                         const discountPercent = getProductDiscountPercentage(product);
//                         const originalPriceRange = isOnSale ? getProductOriginalPriceRange(product) : null;
                        
//                         return (
//                           <div
//                             key={product.id}
//                             className={`product-card ${isOutOfStock ? 'out-of-stock' : ''}`}
//                           >
//                             <div className="product-image">
//                               <img
//                                 src={getProductImage(product)}
//                                 alt={product.name}
//                                 loading="lazy"
//                               />
//                               <div className="product-overlay">
//                                 <button
//                                   className="quick-view-btn"
//                                   onClick={() => handleQuickView(product)}
//                                   aria-label={`Quick view ${product.name}`}
//                                 >
//                                   <FaEye /> Quick View
//                                 </button>
//                               </div>
//                               {/* Category Badge */}
//                               {product.category && (
//                                 <div className="category-badge">
//                                   {getCategoryIcon(product.category)}
//                                   <span>{getCategoryDisplayName(product.category)}</span>
//                                 </div>
//                               )}
//                               {/* Sale Badge */}
//                               {isOnSale && (
//                                 <div className="sale-badge">
//                                   {discountPercent > 0 ? `${discountPercent}% OFF` : 'SALE'}
//                                 </div>
//                               )}
//                               {/* Variant count badge */}
//                               {product.variants && product.variants.length > 1 && (
//                                 <div className="variant-count-badge">
//                                   <FaPalette /> {product.variants.length} colors
//                                 </div>
//                               )}
//                             </div>

//                             <div className="product-info">
//                               <h3 className="product-title">{product.name}</h3>

//                               <div className="product-pricing">
//                                 <span className="current-price">
//                                   {priceRange}
//                                 </span>
//                                 {isOnSale && originalPriceRange && originalPriceRange !== priceRange && (
//                                   <span className="original-price">
//                                     {originalPriceRange}
//                                   </span>
//                                 )}
//                                 {/* {isOnSale && discountPercent > 0 && (
//                                   <span className="discount-badge">
//                                     -{discountPercent}%
//                                   </span>
//                                 )} */}
//                               </div>

//                               {/* Show first variant color for preview */}
//                               {product.variants && product.variants.length > 0 && (
//                                 <div className="product-colors-preview">
//                                   {product.variants.slice(0, 4).map((variant, idx) => (
//                                     <span
//                                       key={idx}
//                                       className="color-swatch"
//                                       style={{ backgroundColor: variant.color_code || '#ccc' }}
//                                       title={variant.color_name}
//                                     />
//                                   ))}
//                                   {product.variants.length > 4 && (
//                                     <span className="more-colors">+{product.variants.length - 4}</span>
//                                   )}
//                                 </div>
//                               )}

//                               <div className="product-meta">
//                                 <span
//                                   className="stock-status"
//                                   style={{
//                                     color: isOutOfStock ? '#dc3545' : '#28a745',
//                                   }}
//                                 >
//                                   {isOutOfStock
//                                     ? 'Out of stock'
//                                     : `${totalStock} in stock`}
//                                 </span>
//                               </div>

//                               <div className="product-actions">
//                                 <button
//                                   className="add-to-cart-btn"
//                                   onClick={() => addToCart(product, 0, 1)}
//                                   disabled={isOutOfStock || loadingItems[`${product.id}-${product.variants?.[0]?.id}`]}
//                                 >
//                                   {loadingItems[`${product.id}-${product.variants?.[0]?.id}`] ? (
//                                     <span className="btn-text">Adding...</span>
//                                   ) : (
//                                     <>
//                                       <FaShoppingCart />
//                                       <span className="btn-text">
//                                         {isOutOfStock ? 'Out of Stock' : 'Add to Cart'}
//                                       </span>
//                                     </>
//                                   )}
//                                 </button>
//                               </div>
//                             </div>
//                           </div>
//                         );
//                       })
//                     ) : (
//                       <div className="no-results">
//                         <h3>No products found</h3>
//                         <p>Try adjusting your search or filter criteria</p>
//                         <button className="clear-btn" onClick={clearAllFilters}>
//                           Clear All Filters
//                         </button>
//                       </div>
//                     )}
//                   </div>

//                   {/* Pagination */}
//                   {filteredProducts.length > itemsPerPage && (
//                     <div className="pagination">
//                       <button
//                         className="pagination-btn prev"
//                         onClick={() => paginate(currentPage - 1)}
//                         disabled={currentPage === 1}
//                         aria-label="Previous page"
//                       >
//                         <FaChevronLeft />
//                       </button>

//                       <div className="page-numbers">
//                         {Array.from(
//                           { length: Math.min(5, totalPages) },
//                           (_, i) => {
//                             let pageNum;
//                             if (totalPages <= 5) {
//                               pageNum = i + 1;
//                             } else if (currentPage <= 3) {
//                               pageNum = i + 1;
//                             } else if (currentPage >= totalPages - 2) {
//                               pageNum = totalPages - 4 + i;
//                             } else {
//                               pageNum = currentPage - 2 + i;
//                             }

//                             return (
//                               <button
//                                 key={pageNum}
//                                 className={`page-btn ${currentPage === pageNum ? 'active' : ''}`}
//                                 onClick={() => paginate(pageNum)}
//                                 aria-label={`Page ${pageNum}`}
//                                 aria-current={
//                                   currentPage === pageNum ? 'page' : undefined
//                                 }
//                               >
//                                 {pageNum}
//                               </button>
//                             );
//                           },
//                         )}  
//                       </div>

//                       <button
//                         className="pagination-btn next"
//                         onClick={() => paginate(currentPage + 1)}
//                         disabled={currentPage === totalPages}
//                         aria-label="Next page"
//                       >
//                         <FaChevronRight />
//                       </button>
//                     </div>
//                   )}
//                 </>
//               )}
//             </main>
//           </div>
//         </div>

//         {/* ============================================= */}
//         {/* QUICK VIEW MODAL - WITH FULL DETAILS */}
//         {/* ============================================= */}
//         <Modal
//           show={showQuickView}
//           onHide={handleCloseQuickView}
//           size="xl"
//           centered
//           className="quick-view-modal"
//         >
//           {selectedProduct && (
//             <>
//               <Modal.Header closeButton>
//                 <h2>{selectedProduct.name}</h2>
//               </Modal.Header>
//               <Modal.Body>
//                 <div className="quick-view-content">
//                   {/* Images Section */}
//                   <div className="quick-view-images">
//                     {/* Main Image / Video Display */}
//                     <div className="main-media-container">
//                       {(() => {
//                         const selectedVariant = selectedProduct.variants?.[selectedVariantIndex];
//                         const videoUrl = selectedVariant?.video?.video_url || selectedVariant?.video;
//                         const images = selectedVariant?.images || [];
//                         const currentImage = images.length > 0 ? images[0].image_url || images[0].image : null;

//                         if (videoUrl) {
//                           return (
//                             <div className="video-wrapper">
//                               <video 
//                                 ref={videoRef}
//                                 controls 
//                                 className="main-video"
//                                 poster={currentImage || undefined}
//                                 playsInline
//                               >
//                                 <source src={videoUrl} type="video/mp4" />
//                                 Your browser does not support the video tag.
//                               </video>
//                               <div className="media-badge video-badge">
//                                 <FaVideo /> Video
//                               </div>
//                             </div>
//                           );
//                         } else if (currentImage) {
//                           const allImages = images.map(img => img.image_url || img.image);
//                           return (
//                             <div className="image-wrapper">
//                               <img
//                                 src={currentImage}
//                                 alt={selectedProduct.name}
//                                 className="main-image"
//                                 onClick={() => openLightbox(allImages, 0)}
//                               />
//                               <button 
//                                 className="expand-btn"
//                                 onClick={() => openLightbox(allImages, 0)}
//                                 aria-label="View full size"
//                               >
//                                 <FaExpand />
//                               </button>
//                               {images.length > 1 && (
//                                 <div className="image-count">
//                                   {images.length} photos
//                                 </div>
//                               )}
//                             </div>
//                           );
//                         } else {
//                           return (
//                             <div className="image-wrapper">
//                               <img
//                                 src="https://via.placeholder.com/500x400?text=No+Image"
//                                 alt="No image available"
//                                 className="main-image"
//                               />
//                             </div>
//                           );
//                         }
//                       })()}
//                     </div>

//                     {/* Image Thumbnails */}
//                     {(() => {
//                       const selectedVariant = selectedProduct.variants?.[selectedVariantIndex];
//                       const images = selectedVariant?.images || [];
//                       if (images.length > 1) {
//                         const allImages = images.map(img => img.image_url || img.image);
//                         return (
//                           <div className="image-thumbnails">
//                             {allImages.map((img, idx) => (
//                               <img
//                                 key={idx}
//                                 src={img}
//                                 alt={`${selectedProduct.name} ${idx + 1}`}
//                                 className={`thumbnail ${idx === 0 ? 'active' : ''}`}
//                                 onClick={() => {
//                                   const mainImage = document.querySelector('.main-image');
//                                   if (mainImage) {
//                                     mainImage.src = img;
//                                   }
//                                   document.querySelectorAll('.thumbnail').forEach((el, i) => {
//                                     el.classList.toggle('active', i === idx);
//                                   });
//                                 }}
//                               />
//                             ))}
//                           </div>
//                         );
//                       }
//                       return null;
//                     })()}

//                     {/* Variant Color Selector */}
//                     {selectedProduct.variants && selectedProduct.variants.length > 1 && (
//                       <div className="variant-selector">
//                         <label>Select Color:</label>
//                         <div className="variant-options">
//                           {selectedProduct.variants.map((variant, index) => {
//                             const hasVideo = !!variant.video;
//                             const onSale = isVariantOnSale(variant);
//                             return (
//                               <button
//                                 key={variant.id || index}
//                                 className={`variant-option ${selectedVariantIndex === index ? 'active' : ''}`}
//                                 onClick={() => handleVariantChange(index)}
//                                 title={variant.color_name}
//                               >
//                                 <span
//                                   className="variant-color-swatch"
//                                   style={{ backgroundColor: variant.color_code || '#ccc' }}
//                                 />
//                                 <span className="variant-name">{variant.color_name}</span>
//                                 {variant.stock === 0 && (
//                                   <span className="variant-out-of-stock">Out of Stock</span>
//                                 )}
//                                 {onSale && (
//                                   <span className="variant-sale-dot">SALE</span>
//                                 )}
//                                 {hasVideo && (
//                                   <span className="variant-video-badge">
//                                     <FaVideo /> 
//                                   </span>
//                                 )}
//                               </button>
//                             );
//                           })}
//                         </div>
//                       </div>
//                     )}
//                   </div>

//                   {/* Details Section - FULL */}
//                   <div className="quick-view-details">
//                     {/* Product Description */}
//                     {selectedProduct.description && (
//                       <div className="detail-section">
//                         <h4><FaInfoCircle /> Description</h4>
//                         <p className="description">{selectedProduct.description}</p>
//                       </div>
//                     )}

//                     {/* Key Features */}
//                     {selectedProduct.key_features && (
//                       <div className="detail-section">
//                         <h4>Key Features</h4>
//                         <div className="key-features">
//                           {selectedProduct.key_features.split('\n').map((feature, idx) => {
//                             const trimmed = feature.trim();
//                             if (!trimmed) return null;
//                             // Remove bullet points if they exist
//                             const cleanText = trimmed.replace(/^[•\-*]\s*/, '');
//                             return (
//                               <div key={idx} className="feature-item">
//                                 <span className="feature-bullet">•</span>
//                                 <span className="feature-text">{cleanText}</span>
//                               </div>
//                             );
//                           })}
//                         </div>
//                       </div>
//                     )}

//                     {/* How It Works */}
//                     {selectedProduct.how_it_works && (
//                       <div className="detail-section">
//                         <h4>How It Works</h4>
//                         <p className="how-it-works">{selectedProduct.how_it_works}</p>
//                       </div>
//                     )}

//                     {/* Price Section */}
//                     <div className="price-section">
//                       {(() => {
//                         const selectedVariant = selectedProduct.variants?.[selectedVariantIndex];
//                         const onSale = selectedVariant ? isVariantOnSale(selectedVariant) : false;
//                         const currentPrice = selectedVariant ? getVariantCurrentPrice(selectedVariant) : 0;
//                         const originalPrice = selectedVariant ? getVariantOriginalPrice(selectedVariant) : 0;
//                         const discountPercent = selectedVariant ? getVariantDiscountPercentage(selectedVariant) : 0;
                        
//                         return (
//                           <>
//                             <span className="price">
//                               {formatCurrency(currentPrice)}
//                             </span>
//                             {onSale && originalPrice > currentPrice && (
//                               <span className="original-price">
//                                 {formatCurrency(originalPrice)}
//                               </span>
//                             )}
//                             {onSale && discountPercent > 0 && (
//                               <span className="discount-badge">
//                                 -{discountPercent}%
//                               </span>
//                             )}
//                           </>
//                         );
//                       })()}
//                       <span
//                         className="stock-badge"
//                         style={{
//                           color: selectedProduct.variants?.[selectedVariantIndex]?.stock > 0 ? '#28a745' : '#dc3545',
//                         }}
//                       >
//                         {selectedProduct.variants?.[selectedVariantIndex]?.stock > 0
//                           ? `${selectedProduct.variants[selectedVariantIndex].stock} in stock`
//                           : 'Out of stock'}
//                       </span>
//                     </div>

//                     {/* Category & Location */}
//                     <div className="meta-info">
//                       <div className="category">
//                         <FaTag />
//                         <strong>Category:</strong> {getCategoryDisplayName(selectedProduct.category)}
//                       </div>
//                       {selectedProduct.location && (
//                         <div className="location">
//                           <FaMapMarkerAlt />
//                           <strong>Location:</strong> {selectedProduct.location}
//                         </div>
//                       )}
//                     </div>

//                     {/* Available Colors */}
//                     {selectedProduct.variants && selectedProduct.variants.length > 1 && (
//                       <div className="available-colors">
//                         <strong>Available Colors:</strong>
//                         <div className="color-dots">
//                           {selectedProduct.variants.map((variant, idx) => (
//                             <span
//                               key={variant.id || idx}
//                               className={`color-dot ${selectedVariantIndex === idx ? 'active' : ''}`}
//                               style={{ backgroundColor: variant.color_code || '#ccc' }}
//                               onClick={() => handleVariantChange(idx)}
//                               title={variant.color_name}
//                             />
//                           ))}
//                         </div>
//                       </div>
//                     )}

//                     {/* Quantity Selector */}
//                     {selectedProduct.variants && 
//                      selectedProduct.variants[selectedVariantIndex]?.stock > 0 && (
//                       <div className="quantity-selector">
//                         <label>Quantity:</label>
//                         <div className="quantity-controls">
//                           <button
//                             type="button"
//                             onClick={() => {
//                               const newQuantity = Math.max(
//                                 1,
//                                 (selectedProduct.quantity || 1) - 1,
//                               );
//                               setSelectedProduct({
//                                 ...selectedProduct,
//                                 quantity: newQuantity,
//                               });
//                             }}
//                             disabled={selectedProduct.quantity <= 1}
//                             className="quantity-btn"
//                           >
//                             -
//                           </button>
//                           <input
//                             type="number"
//                             min="1"
//                             max={selectedProduct.variants[selectedVariantIndex].stock}
//                             value={selectedProduct.quantity || 1}
//                             onChange={(e) => {
//                               const value = parseInt(e.target.value) || 1;
//                               const newQuantity = Math.min(
//                                 selectedProduct.variants[selectedVariantIndex].stock,
//                                 Math.max(1, value),
//                               );
//                               setSelectedProduct({
//                                 ...selectedProduct,
//                                 quantity: newQuantity,
//                               });
//                             }}
//                             className="quantity-input"
//                           />
//                           <button
//                             type="button"
//                             onClick={() => {
//                               const newQuantity = Math.min(
//                                 selectedProduct.variants[selectedVariantIndex].stock,
//                                 (selectedProduct.quantity || 1) + 1,
//                               );
//                               setSelectedProduct({
//                                 ...selectedProduct,
//                                 quantity: newQuantity,
//                               });
//                             }}
//                             disabled={
//                               selectedProduct.quantity >= 
//                               selectedProduct.variants[selectedVariantIndex].stock
//                             }
//                             className="quantity-btn"
//                           >
//                             +
//                           </button>
//                         </div>
//                         <span className="stock-limit">
//                           Max: {selectedProduct.variants[selectedVariantIndex].stock}
//                         </span>
//                       </div>
//                     )}

//                     {/* Add to Cart Button */}
//                     <div className="quick-view-actions">
//                       <button
//                         className="add-to-cart-btn large"
//                         onClick={() =>
//                           addToCart(
//                             selectedProduct,
//                             selectedVariantIndex,
//                             selectedProduct.quantity || 1,
//                           )
//                         }
//                         disabled={
//                           selectedProduct.variants?.[selectedVariantIndex]?.stock === 0 ||
//                           loadingItems[`${selectedProduct.id}-${selectedProduct.variants?.[selectedVariantIndex]?.id}`]
//                         }
//                       >
//                         {loadingItems[`${selectedProduct.id}-${selectedProduct.variants?.[selectedVariantIndex]?.id}`] ? (
//                           'Adding...'
//                         ) : (
//                           <>
//                             <FaShoppingCart />
//                             {selectedProduct.variants?.[selectedVariantIndex]?.stock === 0
//                               ? 'Out of Stock'
//                               : 'Add to Cart'}
//                           </>
//                         )}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </Modal.Body>
//             </>
//           )}
//         </Modal>

//         {/* ============================================= */}
//         {/* LIGHTBOX MODAL - Full Screen Image Viewer */}
//         {/* ============================================= */}
//         <Modal
//           show={showLightbox}
//           onHide={closeLightbox}
//           fullscreen
//           className="lightbox-modal"
//         >
//           <Modal.Header closeButton>
//             <button
//               className="btn-close-lightbox"
//               onClick={closeLightbox}
//               aria-label="Close"
//             >
//               <FaTimes />
//             </button>
//           </Modal.Header>
//           <Modal.Body>
//             {lightboxImages.length > 0 && (
//               <div className="lightbox-content">
//                 {/* Main Image */}
//                 <div className="lightbox-image-container">
//                   <img
//                     src={lightboxImages[lightboxIndex]}
//                     alt={`Product ${lightboxIndex + 1}`}
//                     className="lightbox-image"
//                   />
                  
//                   {/* Navigation */}
//                   {lightboxImages.length > 1 && (
//                     <>
//                       <button
//                         className="lightbox-nav prev"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           setLightboxIndex((prev) => 
//                             prev === 0 ? lightboxImages.length - 1 : prev - 1
//                           );
//                         }}
//                         aria-label="Previous image"
//                       >
//                         <FaChevronLeft />
//                       </button>
//                       <button
//                         className="lightbox-nav next"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           setLightboxIndex((prev) => 
//                             prev === lightboxImages.length - 1 ? 0 : prev + 1
//                           );
//                         }}
//                         aria-label="Next image"
//                       >
//                         <FaChevronRight />
//                       </button>
//                     </>
//                   )}
//                 </div>

//                 {/* Image Counter */}
//                 {lightboxImages.length > 1 && (
//                   <div className="lightbox-counter">
//                     {lightboxIndex + 1} / {lightboxImages.length}
//                   </div>
//                 )}

//                 {/* Thumbnails */}
//                 {lightboxImages.length > 1 && (
//                   <div className="lightbox-thumbnails">
//                     {lightboxImages.map((img, idx) => (
//                       <img
//                         key={idx}
//                         src={img}
//                         alt={`Thumbnail ${idx + 1}`}
//                         className={`lightbox-thumb ${idx === lightboxIndex ? 'active' : ''}`}
//                         onClick={() => setLightboxIndex(idx)}
//                       />
//                     ))}
//                   </div>
//                 )}
//               </div>
//             )}
//           </Modal.Body>
//         </Modal>

//         {/* ============================================= */}
//         {/* CART PREVIEW */}
//         {/* ============================================= */}
//         {cart && cart.items && cart.items.length > 0 && (
//           <div className="floating-cart">
//             <Link
//               to="/cart"
//               className="floating-cart-content"
//               aria-label="View cart"
//             >
//               <FaShoppingCart className="cart-icon" />
//               <div className="cart-info">
//                 <span className="cart-count">{getCartItemCount()} items</span>
//               </div>
//             </Link>
//           </div>
//         )}

//         {/* Scroll to Top Button */}
//         {showScrollTop && (
//           <button
//             className="scroll-top-btn"
//             onClick={scrollToTop}
//             aria-label="Scroll to top"
//           >
//             <FaChevronUp />
//           </button>
//         )}
//       </div>
//     </>
//   );
// };

// // Helper function for formatting currency
// const formatCurrency = (amount) => {
//   if (!amount || amount === 0) return 'KSh 0';
//   return `KSh ${parseFloat(amount).toLocaleString()}`;
// };

// export default withAuth(ReadyProductsView, 'client');

// src/pages/client/ReadyProducts/ReadyProductsView.jsx
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import {
  FaShoppingCart,
  FaSearch,
  FaEye,
  FaTimes,
  FaChevronLeft,
  FaChevronRight,
  FaChevronUp,
  FaFilter,
  FaChevronDown,
  FaChair,
  FaBoxes,
  FaPaintBrush,
  FaVideo,
  FaExpand,
  FaPalette,
  FaTag,
  FaMapMarkerAlt,
  FaInfoCircle,
} from 'react-icons/fa';
import './readyproducts.scss';
import withAuth from '../../../auth/WithAuth';
import Sidebar from '../../../../components/layout/Sidebar';
import { serverUrlAuth } from '../../../../serverUrl';
import { toast } from 'react-toastify';

const CATEGORY_CONFIG = [
  { id: 'furniture', name: 'Furniture', icon: FaChair },
  { id: 'decor', name: 'Home Decor', icon: FaPaintBrush },
  { id: 'art', name: 'Art & Crafts', icon: FaPaintBrush },
  { id: 'clothing', name: 'Clothing', icon: FaBoxes },
  { id: 'other', name: 'Other', icon: FaBoxes },
];

const BUDGET_PRESETS = [
  { label: 'Under KSh 5,000', min: 0, max: 5000 },
  { label: 'KSh 5,000 - KSh 10,000', min: 5000, max: 10000 },
  { label: 'KSh 10,000 - KSh 25,000', min: 10000, max: 25000 },
  { label: 'KSh 25,000 - KSh 50,000', min: 25000, max: 50000 },
  { label: 'KSh 50,000 - KSh 100,000', min: 50000, max: 100000 },
  { label: 'Over KSh 100,000', min: 100000, max: Infinity },
];

const ReadyProductsView = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [categories, setCategories] = useState([]);
  const [cart, setCart] = useState(null);
  const [loadingItems, setLoadingItems] = useState({});
  const [sortBy, setSortBy] = useState('featured');
  const [priceRange, setPriceRange] = useState({ min: 0, max: 1000000 });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(8);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [selectedBudgetPreset, setSelectedBudgetPreset] = useState(null);

  const [showQuickView, setShowQuickView] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedVariantIndex, setSelectedVariantIndex] = useState(0);

  const [showLightbox, setShowLightbox] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const videoRef = useRef(null);

  useEffect(() => {
    fetchProducts();
    fetchCart();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (products.length > 0) buildCategoriesFromProducts();
  }, [products]);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await serverUrlAuth.get(
        'projects/client-list-ready-made-products/',
      );
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
      toast.error('Failed to load products');
    } finally {
      setLoading(false);
    }
  };

  const fetchCart = async () => {
    try {
      const response = await serverUrlAuth.get('cart/');
      setCart(response.data);
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  };

  const buildCategoriesFromProducts = () => {
    const categoryMap = new Map();
    products.forEach((product) => {
      const category = product.category || 'furniture';
      const config = CATEGORY_CONFIG.find((c) => c.id === category);
      const categoryName = config
        ? config.name
        : category.charAt(0).toUpperCase() + category.slice(1);
      const Icon = config ? config.icon : FaBoxes;
      if (!categoryMap.has(category)) {
        categoryMap.set(category, {
          id: category,
          name: categoryName,
          icon: Icon,
          count: 0,
        });
      }
      categoryMap.get(category).count++;
    });
    const categoriesArray = Array.from(categoryMap.values()).sort(
      (a, b) => b.count - a.count,
    );
    setCategories(categoriesArray);
  };

  const handleScroll = () => setShowScrollTop(window.pageYOffset > 300);
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const isVariantOnSale = (variant) => {
    if (!variant) return false;
    if (variant.is_on_sale !== undefined) return variant.is_on_sale === true;
    if (!variant.sale_start_date || !variant.sale_end_date) return false;
    const now = new Date();
    return now >= new Date(variant.sale_start_date) && now <= new Date(variant.sale_end_date);
  };

  const getVariantCurrentPrice = (variant) => {
    if (!variant) return 0;
    if (isVariantOnSale(variant) && variant.selling_price) return parseFloat(variant.selling_price);
    return parseFloat(variant.original_price || 0);
  };

  const getVariantOriginalPrice = (variant) =>
    variant ? parseFloat(variant.original_price || 0) : 0;

  const getVariantDiscountPercentage = (variant) => {
    if (!variant || !isVariantOnSale(variant)) return 0;
    const original = parseFloat(variant.original_price || 0);
    const selling = parseFloat(variant.selling_price || 0);
    if (original === 0 || selling === 0) return 0;
    return Math.round(((original - selling) / original) * 100);
  };

  const getProductPrice = (product) => {
    if (!product.variants || product.variants.length === 0) return 0;
    return Math.min(...product.variants.map((v) => getVariantCurrentPrice(v)));
  };

  const getProductPriceRange = (product) => {
    if (!product.variants || product.variants.length === 0) return 'KSh 0';
    const prices = product.variants.map((v) => getVariantCurrentPrice(v));
    const min = Math.min(...prices);
    const max = Math.max(...prices);
    if (min === max) return formatCurrency(min);
    return `${formatCurrency(min)} - ${formatCurrency(max)}`;
  };

  const getProductOriginalPriceRange = (product) => {
    if (!product.variants || product.variants.length === 0) return null;
    const prices = product.variants.map((v) => getVariantOriginalPrice(v));
    const min = Math.min(...prices);
    const max = Math.max(...prices);
    if (min === max) return formatCurrency(min);
    return `${formatCurrency(min)} - ${formatCurrency(max)}`;
  };

  const isProductOnSale = (product) =>
    product.variants?.some((v) => isVariantOnSale(v)) || false;

  const getProductDiscountPercentage = (product) => {
    if (!product.variants || product.variants.length === 0) return 0;
    return Math.max(...product.variants.map((v) => getVariantDiscountPercentage(v)));
  };

  const getProductStock = (product) => {
    if (!product.variants || product.variants.length === 0) return 0;
    return product.variants.reduce((sum, v) => sum + (v.stock || 0), 0);
  };

  const getProductImage = (product) => {
    if (product.variants && product.variants.length > 0) {
      const firstVariant = product.variants[0];
      if (firstVariant.images && firstVariant.images.length > 0) {
        return firstVariant.images[0].image_url || firstVariant.images[0].image;
      }
    }
    return 'https://via.placeholder.com/300x200?text=No+Image';
  };

  const openLightbox = (images, index = 0) => {
    if (images && images.length > 0) {
      setLightboxImages(images);
      setLightboxIndex(index);
      setShowLightbox(true);
    }
  };

  const closeLightbox = () => {
    setShowLightbox(false);
    setLightboxImages([]);
    setLightboxIndex(0);
  };

  const addToCart = async (product, variantIndex, quantity = 1) => {
    const variant = product.variants?.[variantIndex];
    if (!variant) return toast.error('Variant not found');
    if (variant.stock === 0) return toast.error('Sorry, this item is out of stock!');

    const loadingKey = `${product.id}-${variant.id}`;
    setLoadingItems((prev) => ({ ...prev, [loadingKey]: true }));

    try {
      await serverUrlAuth.post('cart/add/', {
        variant_id: variant.id,
        quantity,
      });
      await fetchCart();
      const variantName = variant.color_name || '';
      toast.success(
        `${quantity} ${product.name}${variantName ? ` (${variantName})` : ''} added to cart!`,
      );
      if (showQuickView) handleCloseQuickView();
    } catch (error) {
      console.error('Error adding to cart:', error);
      toast.error(error.response?.data?.error || 'Failed to add to cart');
    } finally {
      setLoadingItems((prev) => ({ ...prev, [loadingKey]: false }));
    }
  };

  const handleQuickView = (product) => {
    setSelectedProduct({ ...product, quantity: 1, selectedVariantIndex: 0 });
    setSelectedVariantIndex(0);
    setShowQuickView(true);
  };

  const handleCloseQuickView = () => {
    setShowQuickView(false);
    setSelectedProduct(null);
    setSelectedVariantIndex(0);
  };

  const handleVariantChange = (index) => {
    setSelectedVariantIndex(index);
    if (selectedProduct) {
      setSelectedProduct({ ...selectedProduct, selectedVariantIndex: index });
    }
  };

  const handleBudgetPresetSelect = (preset) => {
    setSelectedBudgetPreset(preset.label);
    setPriceRange({ min: preset.min, max: preset.max });
    setCurrentPage(1);
  };

  const handleCustomPriceRange = (type, value) => {
    let newMin = priceRange.min;
    let newMax = priceRange.max;
    if (type === 'min') newMin = value;
    else newMax = value;
    setPriceRange({ min: newMin, max: newMax });
    setSelectedBudgetPreset(null);
    setCurrentPage(1);
  };

  const clearAllFilters = () => {
    setSelectedCategory('all');
    setSearchTerm('');
    setPriceRange({ min: 0, max: 1000000 });
    setSortBy('featured');
    setSelectedBudgetPreset(null);
    setShowMobileFilters(false);
  };

  const getCategoryIcon = (categoryId) => {
    const category = CATEGORY_CONFIG.find((c) => c.id === categoryId);
    if (category && category.icon) {
      const Icon = category.icon;
      return <Icon />;
    }
    return <FaBoxes />;
  };

  const filteredProducts = products
    .filter((product) => {
      const matchesSearch =
        product.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.description?.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesCategory =
        selectedCategory === 'all' ||
        product.category?.toLowerCase() === selectedCategory.toLowerCase();
      const productPrice = getProductPrice(product);
      const matchesPrice = productPrice >= priceRange.min && productPrice <= priceRange.max;
      return matchesSearch && matchesCategory && matchesPrice;
    })
    .sort((a, b) => {
      const priceA = getProductPrice(a);
      const priceB = getProductPrice(b);
      switch (sortBy) {
        case 'price-low':
          return priceA - priceB;
        case 'price-high':
          return priceB - priceA;
        case 'newest':
          return new Date(b.created_at) - new Date(a.created_at);
        default:
          return 0;
      }
    });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredProducts.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    if (window.innerWidth <= 768) {
      document.querySelector('.products-grid')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const getCategoryDisplayName = (categoryId) => {
    const category = CATEGORY_CONFIG.find((c) => c.id === categoryId);
    return category ? category.name : categoryId || 'Furniture';
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (showLightbox) {
        if (e.key === 'ArrowLeft') {
          setLightboxIndex((prev) => (prev === 0 ? lightboxImages.length - 1 : prev - 1));
        } else if (e.key === 'ArrowRight') {
          setLightboxIndex((prev) =>
            prev === lightboxImages.length - 1 ? 0 : prev + 1,
          );
        } else if (e.key === 'Escape') {
          closeLightbox();
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [showLightbox, lightboxImages.length]);

  const getCartItemCount = () => {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce((sum, item) => sum + item.quantity, 0);
  };

  return (
    <>
      <Sidebar />
      <div className="modern-dashboard shop-shell">
        <div className="ready-products-page">
          {/* Hero */}
          {/* <header className="hero-craftsmanship">
            <div className="hero-pattern"></div>
            <div className="hero-content-modern">
              <div className="welcome-badge">
                <FaBoxes className="badge-icon" />
                <span>Ready Made Shop</span>
              </div>
              <h1 className="hero-title">
                <span className="gradient-text">Handcrafted</span>
                <span className="hero-accent">For You</span>
              </h1>
              <p className="hero-subtitle">
                Discover unique, handcrafted pieces from talented artisans —
                ready to ship, no waiting, no negotiation.
              </p>
            </div>
          </header> */}

          <div className="shop-container">
            <button
              className="mobile-filter-toggle"
              onClick={() => setShowMobileFilters(!showMobileFilters)}
              aria-label="Toggle filters"
            >
              <FaFilter /> Filters
              <span className="filter-count">
                {selectedCategory !== 'all' ||
                searchTerm ||
                priceRange.min > 0 ||
                priceRange.max < 1000000
                  ? '●'
                  : ''}
              </span>
              <FaChevronDown className={`arrow ${showMobileFilters ? 'open' : ''}`} />
            </button>

            <div className="shop-layout">
              {/* Sidebar */}
              <aside className={`shop-sidebar ${showMobileFilters ? 'show' : ''}`}>
                <div className="sidebar-header">
                  <h3>Filters</h3>
                  <button
                    className="close-sidebar"
                    onClick={() => setShowMobileFilters(false)}
                    aria-label="Close filters"
                  >
                    <FaTimes />
                  </button>
                </div>

                {categories.length > 0 && (
                  <div className="filter-section">
                    <h4>Categories</h4>
                    <div className="category-list">
                      <button
                        className={`category-item ${selectedCategory === 'all' ? 'active' : ''}`}
                        onClick={() => {
                          setSelectedCategory('all');
                          setShowMobileFilters(false);
                        }}
                      >
                        <span>All Categories</span>
                        <span className="count">{products.length}</span>
                      </button>
                      {categories.map((cat) => {
                        const Icon = cat.icon;
                        return (
                          <button
                            key={cat.id}
                            className={`category-item ${selectedCategory === cat.id ? 'active' : ''}`}
                            onClick={() => {
                              setSelectedCategory(cat.id);
                              setShowMobileFilters(false);
                            }}
                          >
                            <span>
                              <Icon /> {cat.name}
                            </span>
                            <span className="count">{cat.count}</span>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}

                <div className="filter-section">
                  <h4>Filter by Budget</h4>
                  <div className="budget-presets">
                    {BUDGET_PRESETS.map((preset) => (
                      <button
                        key={preset.label}
                        className={`budget-preset-btn ${selectedBudgetPreset === preset.label ? 'active' : ''}`}
                        onClick={() => handleBudgetPresetSelect(preset)}
                      >
                        {preset.label}
                      </button>
                    ))}
                  </div>

                  {(priceRange.min > 0 || priceRange.max < 1000000) && (
                    <div className="active-budget-range">
                      <span>Current budget: </span>
                      <strong>
                        {priceRange.min > 0
                          ? `KSh ${priceRange.min.toLocaleString()}`
                          : 'KSh 0'}{' '}
                        -{' '}
                        {priceRange.max === Infinity
                          ? 'Any'
                          : `KSh ${priceRange.max.toLocaleString()}`}
                      </strong>
                      <button
                        className="clear-budget"
                        onClick={() => {
                          setPriceRange({ min: 0, max: 1000000 });
                          setSelectedBudgetPreset(null);
                        }}
                      >
                        Clear
                      </button>
                    </div>
                  )}
                </div>

                <div className="filter-section">
                  <h4>Price Range (KSh)</h4>
                  <div className="price-range">
                    <div className="price-inputs">
                      <div className="input-group">
                        <label htmlFor="min-price">Min</label>
                        <input
                          id="min-price"
                          type="number"
                          value={priceRange.min}
                          onChange={(e) =>
                            handleCustomPriceRange('min', Number(e.target.value))
                          }
                          placeholder="0"
                          min="0"
                        />
                      </div>
                      <span className="range-separator">to</span>
                      <div className="input-group">
                        <label htmlFor="max-price">Max</label>
                        <input
                          id="max-price"
                          type="number"
                          value={priceRange.max === Infinity ? '' : priceRange.max}
                          onChange={(e) =>
                            handleCustomPriceRange('max', Number(e.target.value))
                          }
                          placeholder="1000000"
                          min="0"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="filter-actions">
                  <button
                    className="apply-filters-btn"
                    onClick={() => setShowMobileFilters(false)}
                  >
                    Apply Filters
                  </button>
                  <button className="clear-filters-btn" onClick={clearAllFilters}>
                    Clear All
                  </button>
                </div>
              </aside>

              {/* Main */}
              <main className="shop-main">
                <div className="shop-toolbar">
                  <div className="search-box">
                    <FaSearch className="search-icon" />
                    <input
                      type="text"
                      placeholder="Search products..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      aria-label="Search products"
                    />
                    {searchTerm && (
                      <button
                        className="clear-search"
                        onClick={() => setSearchTerm('')}
                        aria-label="Clear search"
                      >
                        <FaTimes />
                      </button>
                    )}
                  </div>

                  <div className="sort-box">
                    <select
                      value={sortBy}
                      onChange={(e) => setSortBy(e.target.value)}
                      aria-label="Sort products by"
                    >
                      <option value="featured">Featured</option>
                      <option value="price-low">Price: Low to High</option>
                      <option value="price-high">Price: High to Low</option>
                      <option value="newest">Newest</option>
                    </select>
                  </div>
                </div>

                {(selectedCategory !== 'all' ||
                  searchTerm ||
                  priceRange.min > 0 ||
                  priceRange.max < 1000000) && (
                  <div className="active-filters">
                    <span>Active filters:</span>
                    {selectedCategory !== 'all' && (
                      <span className="filter-tag">
                        {getCategoryDisplayName(selectedCategory)}
                        <button onClick={() => setSelectedCategory('all')}>×</button>
                      </span>
                    )}
                    {searchTerm && (
                      <span className="filter-tag">
                        Search: {searchTerm}
                        <button onClick={() => setSearchTerm('')}>×</button>
                      </span>
                    )}
                    {(priceRange.min > 0 || priceRange.max < 1000000) && (
                      <span className="filter-tag">
                        Budget:{' '}
                        {priceRange.min > 0
                          ? `KSh ${priceRange.min.toLocaleString()}`
                          : 'KSh 0'}{' '}
                        -{' '}
                        {priceRange.max === Infinity
                          ? 'Any'
                          : `KSh ${priceRange.max.toLocaleString()}`}
                        <button
                          onClick={() => {
                            setPriceRange({ min: 0, max: 1000000 });
                            setSelectedBudgetPreset(null);
                          }}
                        >
                          ×
                        </button>
                      </span>
                    )}
                    <button className="clear-all-filters" onClick={clearAllFilters}>
                      Clear all
                    </button>
                  </div>
                )}

                {!loading && filteredProducts.length > 0 && (
                  <div className="results-info">
                    <p>
                      Showing{' '}
                      <span>
                        {indexOfFirstItem + 1}-
                        {Math.min(indexOfLastItem, filteredProducts.length)}
                      </span>{' '}
                      of <span>{filteredProducts.length}</span> products
                    </p>
                  </div>
                )}

                {loading ? (
                  <div className="loading-container">
                    <div className="spinner"></div>
                    <p>Discovering amazing creations...</p>
                  </div>
                ) : (
                  <>
                    <div className="products-grid">
                      {currentItems.length > 0 ? (
                        currentItems.map((product) => {
                          const totalStock = getProductStock(product);
                          const priceRangeText = getProductPriceRange(product);
                          const isOutOfStock = totalStock === 0;
                          const isOnSale = isProductOnSale(product);
                          const discountPercent = getProductDiscountPercentage(product);
                          const originalPriceRange = isOnSale
                            ? getProductOriginalPriceRange(product)
                            : null;

                          return (
                            <div
                              key={product.id}
                              className={`product-card ${isOutOfStock ? 'out-of-stock' : ''}`}
                            >
                              <div className="product-image">
                                <img
                                  src={getProductImage(product)}
                                  alt={product.name}
                                  loading="lazy"
                                />
                                <div className="product-overlay">
                                  <button
                                    className="quick-view-btn"
                                    onClick={() => handleQuickView(product)}
                                    aria-label={`Quick view ${product.name}`}
                                  >
                                    <FaEye /> Quick View
                                  </button>
                                </div>
                                {product.category && (
                                  <div className="category-badge">
                                    {getCategoryIcon(product.category)}
                                    <span>{getCategoryDisplayName(product.category)}</span>
                                  </div>
                                )}
                                {isOnSale && (
                                  <div className="sale-badge">
                                    {discountPercent > 0 ? `${discountPercent}% OFF` : 'SALE'}
                                  </div>
                                )}
                                {product.variants && product.variants.length > 1 && (
                                  <div className="variant-count-badge">
                                    <FaPalette /> {product.variants.length} colors
                                  </div>
                                )}
                              </div>

                              <div className="product-info">
                                <h3 className="product-title">{product.name}</h3>

                                <div className="product-pricing">
                                  <span className="current-price">{priceRangeText}</span>
                                  {isOnSale &&
                                    originalPriceRange &&
                                    originalPriceRange !== priceRangeText && (
                                      <span className="original-price">
                                        {originalPriceRange}
                                      </span>
                                    )}
                                </div>

                                {product.variants && product.variants.length > 0 && (
                                  <div className="product-colors-preview">
                                    {product.variants.slice(0, 4).map((variant, idx) => (
                                      <span
                                        key={idx}
                                        className="color-swatch"
                                        style={{
                                          backgroundColor: variant.color_code || '#ccc',
                                        }}
                                        title={variant.color_name}
                                      />
                                    ))}
                                    {product.variants.length > 4 && (
                                      <span className="more-colors">
                                        +{product.variants.length - 4}
                                      </span>
                                    )}
                                  </div>
                                )}

                                <div className="product-meta">
                                  <span
                                    className="stock-status"
                                    style={{
                                      color: isOutOfStock ? '#8b2e1a' : '#6b8e23',
                                    }}
                                  >
                                    {isOutOfStock
                                      ? 'Out of stock'
                                      : `${totalStock} in stock`}
                                  </span>
                                </div>

                                <div className="product-actions">
                                  <button
                                    className="add-to-cart-btn"
                                    onClick={() => addToCart(product, 0, 1)}
                                    disabled={
                                      isOutOfStock ||
                                      loadingItems[
                                        `${product.id}-${product.variants?.[0]?.id}`
                                      ]
                                    }
                                  >
                                    {loadingItems[
                                      `${product.id}-${product.variants?.[0]?.id}`
                                    ] ? (
                                      <span className="btn-text">Adding...</span>
                                    ) : (
                                      <>
                                        <FaShoppingCart />
                                        <span className="btn-text">
                                          {isOutOfStock ? 'Out of Stock' : 'Add to Cart'}
                                        </span>
                                      </>
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="no-results">
                          <h3>No products found</h3>
                          <p>Try adjusting your search or filter criteria</p>
                          <button className="clear-btn" onClick={clearAllFilters}>
                            Clear All Filters
                          </button>
                        </div>
                      )}
                    </div>

                    {filteredProducts.length > itemsPerPage && (
                      <div className="pagination">
                        <button
                          className="pagination-btn prev"
                          onClick={() => paginate(currentPage - 1)}
                          disabled={currentPage === 1}
                          aria-label="Previous page"
                        >
                          <FaChevronLeft />
                        </button>

                        <div className="page-numbers">
                          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                            let pageNum;
                            if (totalPages <= 5) pageNum = i + 1;
                            else if (currentPage <= 3) pageNum = i + 1;
                            else if (currentPage >= totalPages - 2)
                              pageNum = totalPages - 4 + i;
                            else pageNum = currentPage - 2 + i;

                            return (
                              <button
                                key={pageNum}
                                className={`page-btn ${currentPage === pageNum ? 'active' : ''}`}
                                onClick={() => paginate(pageNum)}
                              >
                                {pageNum}
                              </button>
                            );
                          })}
                        </div>

                        <button
                          className="pagination-btn next"
                          onClick={() => paginate(currentPage + 1)}
                          disabled={currentPage === totalPages}
                          aria-label="Next page"
                        >
                          <FaChevronRight />
                        </button>
                      </div>
                    )}
                  </>
                )}
              </main>
            </div>
          </div>

          {/* Quick View Modal */}
          <Modal
            show={showQuickView}
            onHide={handleCloseQuickView}
            size="xl"
            centered
            className="quick-view-modal"
          >
            {selectedProduct && (
              <>
                <Modal.Header closeButton>
                  <h2>{selectedProduct.name}</h2>
                </Modal.Header>
                <Modal.Body>
                  <div className="quick-view-content">
                    <div className="quick-view-images">
                      <div className="main-media-container">
                        {(() => {
                          const selectedVariant =
                            selectedProduct.variants?.[selectedVariantIndex];
                          const videoUrl =
                            selectedVariant?.video?.video_url || selectedVariant?.video;
                          const images = selectedVariant?.images || [];
                          const currentImage =
                            images.length > 0
                              ? images[0].image_url || images[0].image
                              : null;

                          if (videoUrl) {
                            return (
                              <div className="video-wrapper">
                                <video
                                  ref={videoRef}
                                  controls
                                  className="main-video"
                                  poster={currentImage || undefined}
                                  playsInline
                                >
                                  <source src={videoUrl} type="video/mp4" />
                                  Your browser does not support the video tag.
                                </video>
                                <div className="media-badge video-badge">
                                  <FaVideo /> Video
                                </div>
                              </div>
                            );
                          } else if (currentImage) {
                            const allImages = images.map(
                              (img) => img.image_url || img.image,
                            );
                            return (
                              <div className="image-wrapper">
                                <img
                                  src={currentImage}
                                  alt={selectedProduct.name}
                                  className="main-image"
                                  onClick={() => openLightbox(allImages, 0)}
                                />
                                <button
                                  className="expand-btn"
                                  onClick={() => openLightbox(allImages, 0)}
                                  aria-label="View full size"
                                >
                                  <FaExpand />
                                </button>
                                {images.length > 1 && (
                                  <div className="image-count">
                                    {images.length} photos
                                  </div>
                                )}
                              </div>
                            );
                          } else {
                            return (
                              <div className="image-wrapper">
                                <img
                                  src="https://via.placeholder.com/500x400?text=No+Image"
                                  alt="No image available"
                                  className="main-image"
                                />
                              </div>
                            );
                          }
                        })()}
                      </div>

                      {selectedProduct.variants &&
                        selectedProduct.variants.length > 1 && (
                          <div className="variant-selector">
                            <label>Select Color:</label>
                            <div className="variant-options">
                              {selectedProduct.variants.map((variant, index) => {
                                const hasVideo = !!variant.video;
                                const onSale = isVariantOnSale(variant);
                                return (
                                  <button
                                    key={variant.id || index}
                                    className={`variant-option ${selectedVariantIndex === index ? 'active' : ''}`}
                                    onClick={() => handleVariantChange(index)}
                                    title={variant.color_name}
                                  >
                                    <span
                                      className="variant-color-swatch"
                                      style={{
                                        backgroundColor: variant.color_code || '#ccc',
                                      }}
                                    />
                                    <span className="variant-name">
                                      {variant.color_name}
                                    </span>
                                    {variant.stock === 0 && (
                                      <span className="variant-out-of-stock">
                                        Out of Stock
                                      </span>
                                    )}
                                    {onSale && (
                                      <span className="variant-sale-dot">SALE</span>
                                    )}
                                    {hasVideo && (
                                      <span className="variant-video-badge">
                                        <FaVideo />
                                      </span>
                                    )}
                                  </button>
                                );
                              })}
                            </div>
                          </div>
                        )}
                    </div>

                    <div className="quick-view-details">
                      {selectedProduct.description && (
                        <div className="detail-section">
                          <h4>
                            <FaInfoCircle /> Description
                          </h4>
                          <p className="description">{selectedProduct.description}</p>
                        </div>
                      )}

                      {selectedProduct.key_features && (
                        <div className="detail-section">
                          <h4>Key Features</h4>
                          <div className="key-features">
                            {selectedProduct.key_features
                              .split('\n')
                              .map((feature, idx) => {
                                const trimmed = feature.trim();
                                if (!trimmed) return null;
                                const cleanText = trimmed.replace(/^[•\-*]\s*/, '');
                                return (
                                  <div key={idx} className="feature-item">
                                    <span className="feature-bullet">•</span>
                                    <span className="feature-text">{cleanText}</span>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      )}

                      {selectedProduct.how_it_works && (
                        <div className="detail-section">
                          <h4>How It Works</h4>
                          <p className="how-it-works">
                            {selectedProduct.how_it_works}
                          </p>
                        </div>
                      )}

                      <div className="price-section">
                        {(() => {
                          const selectedVariant =
                            selectedProduct.variants?.[selectedVariantIndex];
                          const onSale = selectedVariant
                            ? isVariantOnSale(selectedVariant)
                            : false;
                          const currentPrice = selectedVariant
                            ? getVariantCurrentPrice(selectedVariant)
                            : 0;
                          const originalPrice = selectedVariant
                            ? getVariantOriginalPrice(selectedVariant)
                            : 0;
                          const discountPercent = selectedVariant
                            ? getVariantDiscountPercentage(selectedVariant)
                            : 0;

                          return (
                            <>
                              <span className="price">
                                {formatCurrency(currentPrice)}
                              </span>
                              {onSale && originalPrice > currentPrice && (
                                <span className="original-price">
                                  {formatCurrency(originalPrice)}
                                </span>
                              )}
                              {onSale && discountPercent > 0 && (
                                <span className="discount-badge">
                                  -{discountPercent}%
                                </span>
                              )}
                            </>
                          );
                        })()}
                        <span
                          className="stock-badge"
                          style={{
                            color:
                              selectedProduct.variants?.[selectedVariantIndex]?.stock > 0
                                ? '#6b8e23'
                                : '#8b2e1a',
                          }}
                        >
                          {selectedProduct.variants?.[selectedVariantIndex]?.stock > 0
                            ? `${selectedProduct.variants[selectedVariantIndex].stock} in stock`
                            : 'Out of stock'}
                        </span>
                      </div>

                      <div className="meta-info">
                        <div className="category">
                          <FaTag />
                          <strong>Category:</strong>{' '}
                          {getCategoryDisplayName(selectedProduct.category)}
                        </div>
                        {selectedProduct.location && (
                          <div className="location">
                            <FaMapMarkerAlt />
                            <strong>Location:</strong> {selectedProduct.location}
                          </div>
                        )}
                      </div>

                      {selectedProduct.variants &&
                        selectedProduct.variants[selectedVariantIndex]?.stock > 0 && (
                          <div className="quantity-selector">
                            <label>Quantity:</label>
                            <div className="quantity-controls">
                              <button
                                type="button"
                                onClick={() => {
                                  const newQuantity = Math.max(
                                    1,
                                    (selectedProduct.quantity || 1) - 1,
                                  );
                                  setSelectedProduct({
                                    ...selectedProduct,
                                    quantity: newQuantity,
                                  });
                                }}
                                disabled={selectedProduct.quantity <= 1}
                                className="quantity-btn"
                              >
                                -
                              </button>
                              <input
                                type="number"
                                min="1"
                                max={
                                  selectedProduct.variants[selectedVariantIndex].stock
                                }
                                value={selectedProduct.quantity || 1}
                                onChange={(e) => {
                                  const value = parseInt(e.target.value) || 1;
                                  const newQuantity = Math.min(
                                    selectedProduct.variants[selectedVariantIndex]
                                      .stock,
                                    Math.max(1, value),
                                  );
                                  setSelectedProduct({
                                    ...selectedProduct,
                                    quantity: newQuantity,
                                  });
                                }}
                                className="quantity-input"
                              />
                              <button
                                type="button"
                                onClick={() => {
                                  const newQuantity = Math.min(
                                    selectedProduct.variants[selectedVariantIndex]
                                      .stock,
                                    (selectedProduct.quantity || 1) + 1,
                                  );
                                  setSelectedProduct({
                                    ...selectedProduct,
                                    quantity: newQuantity,
                                  });
                                }}
                                disabled={
                                  selectedProduct.quantity >=
                                  selectedProduct.variants[selectedVariantIndex].stock
                                }
                                className="quantity-btn"
                              >
                                +
                              </button>
                            </div>
                            <span className="stock-limit">
                              Max:{' '}
                              {selectedProduct.variants[selectedVariantIndex].stock}
                            </span>
                          </div>
                        )}

                      <div className="quick-view-actions">
                        <button
                          className="add-to-cart-btn large"
                          onClick={() =>
                            addToCart(
                              selectedProduct,
                              selectedVariantIndex,
                              selectedProduct.quantity || 1,
                            )
                          }
                          disabled={
                            selectedProduct.variants?.[selectedVariantIndex]?.stock ===
                              0 ||
                            loadingItems[
                              `${selectedProduct.id}-${selectedProduct.variants?.[selectedVariantIndex]?.id}`
                            ]
                          }
                        >
                          {loadingItems[
                            `${selectedProduct.id}-${selectedProduct.variants?.[selectedVariantIndex]?.id}`
                          ] ? (
                            'Adding...'
                          ) : (
                            <>
                              <FaShoppingCart />
                              {selectedProduct.variants?.[selectedVariantIndex]
                                ?.stock === 0
                                ? 'Out of Stock'
                                : 'Add to Cart'}
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Modal.Body>
              </>
            )}
          </Modal>

          {/* Lightbox */}
          <Modal
            show={showLightbox}
            onHide={closeLightbox}
            fullscreen
            className="lightbox-modal"
          >
            <Modal.Header closeButton>
              <button
                className="btn-close-lightbox"
                onClick={closeLightbox}
                aria-label="Close"
              >
                <FaTimes />
              </button>
            </Modal.Header>
            <Modal.Body>
              {lightboxImages.length > 0 && (
                <div className="lightbox-content">
                  <div className="lightbox-image-container">
                    <img
                      src={lightboxImages[lightboxIndex]}
                      alt={`Product ${lightboxIndex + 1}`}
                      className="lightbox-image"
                    />
                    {lightboxImages.length > 1 && (
                      <>
                        <button
                          className="lightbox-nav prev"
                          onClick={(e) => {
                            e.stopPropagation();
                            setLightboxIndex((prev) =>
                              prev === 0 ? lightboxImages.length - 1 : prev - 1,
                            );
                          }}
                          aria-label="Previous image"
                        >
                          <FaChevronLeft />
                        </button>
                        <button
                          className="lightbox-nav next"
                          onClick={(e) => {
                            e.stopPropagation();
                            setLightboxIndex((prev) =>
                              prev === lightboxImages.length - 1 ? 0 : prev + 1,
                            );
                          }}
                          aria-label="Next image"
                        >
                          <FaChevronRight />
                        </button>
                      </>
                    )}
                  </div>

                  {lightboxImages.length > 1 && (
                    <div className="lightbox-counter">
                      {lightboxIndex + 1} / {lightboxImages.length}
                    </div>
                  )}

                  {lightboxImages.length > 1 && (
                    <div className="lightbox-thumbnails">
                      {lightboxImages.map((img, idx) => (
                        <img
                          key={idx}
                          src={img}
                          alt={`Thumbnail ${idx + 1}`}
                          className={`lightbox-thumb ${idx === lightboxIndex ? 'active' : ''}`}
                          onClick={() => setLightboxIndex(idx)}
                        />
                      ))}
                    </div>
                  )}
                </div>
              )}
            </Modal.Body>
          </Modal>

          {/* Floating Cart */}
          {cart && cart.items && cart.items.length > 0 && (
            <div className="floating-cart">
              <Link to="/cart" className="floating-cart-content" aria-label="View cart">
                <FaShoppingCart className="cart-icon" />
                <div className="cart-info">
                  <span className="cart-count">{getCartItemCount()} items</span>
                </div>
              </Link>
            </div>
          )}

          {/* Scroll to Top */}
          {showScrollTop && (
            <button
              className="scroll-top-btn"
              onClick={scrollToTop}
              aria-label="Scroll to top"
            >
              <FaChevronUp />
            </button>
          )}
        </div>
      </div>
    </>
  );
};

const formatCurrency = (amount) => {
  if (!amount || amount === 0) return 'KSh 0';
  return `KSh ${parseFloat(amount).toLocaleString()}`;
};

export default withAuth(ReadyProductsView, 'client');